// Countdown announcement banner. The target is an absolute epoch resolved in
// Liquid against the store's timezone, so the viewer's clock offset cannot
// shift it. Liquid also prints the opening digits, so the first paint is
// already right and this only keeps them moving.
//
// Every tick re-queries the DOM instead of binding per instance: that is how
// theme-editor section load and unload are handled without any bookkeeping.
(function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function put(el, key, value) {
    var node = el.querySelector('[data-cdb="' + key + '"]');
    if (node && node.textContent !== value) node.textContent = value;
  }

  function stored(key) {
    try { return localStorage.getItem(key) === '1'; } catch (e) { return false; }
  }

  function tick() {
    var design = window.Shopify && Shopify.designMode;
    Array.prototype.forEach.call(document.querySelectorAll('[data-countdown]'), function (el) {
      if (!design && el.dataset.cdbKey && stored(el.dataset.cdbKey)) {
        el.hidden = true;
        return;
      }
      var end = Number(el.dataset.end) * 1000;
      if (!end) return;
      var now = Date.now();
      if (now >= end) {
        var every = Number(el.dataset.restart) * 3600000;
        if (el.dataset.expire === 'restart' && every > 0) {
          end += (Math.floor((now - end) / every) + 1) * every;
          el.dataset.end = Math.round(end / 1000);
        } else if (el.dataset.expire === 'hide') {
          el.hidden = true;
          return;
        } else {
          el.dataset.state = 'expired';
          return;
        }
      }
      if (el.dataset.state === 'expired') el.removeAttribute('data-state');
      var left = Math.max(0, Math.floor((end - now) / 1000));
      var days = el.dataset.days === 'true' ? Math.floor(left / 86400) : 0;
      put(el, 'days', pad(days));
      put(el, 'hours', pad(Math.floor(left / 3600) - days * 24));
      put(el, 'minutes', pad(Math.floor(left / 60) % 60));
      put(el, 'seconds', pad(left % 60));
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cdb-dismiss]');
    if (!btn) return;
    var el = btn.closest('[data-countdown]');
    if (!el) return;
    el.hidden = true;
    try { localStorage.setItem(el.dataset.cdbKey, '1'); } catch (err) {}
  });

  tick();
  setInterval(tick, 1000);
})();
